import React from "react";
import { Modal, Form, Input, InputNumber, Button, message, ColorPicker } from "antd";
import { PostRanking } from "../../../../dao/jutge/PostRanking";

interface Props {
    visible: boolean;
    onClose: (created: boolean) => void;
    origenTipo?: string;
}

const NuevoPremioModal: React.FC<Props> = ({ visible, onClose, origenTipo = 'PROBLEMA' }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = React.useState(false);

    async function submit(values: any) {
        try {
            setLoading(true);
            const payload = { ...values, origen_tipo: origenTipo };
            console.log("ENVIADO:", payload);
            await PostRanking(payload);
            message.success("Trofeu creat correctament");
            onClose(true);
            form.resetFields();
        } catch {
            message.error("Error creant el trofeu");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal
            title="Nou trofeu"
            open={visible}
            onCancel={() => onClose(false)}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={submit}>
                <Form.Item
                    label="Nom del trofeu"
                    name="nom"
                    rules={[{ required: true, message: "Nom requerit" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Punts"
                    name="punts"
                    rules={[{ required: true, message: "Punts requerits" }]}
                >
                    <InputNumber min={0} style={{ width: "100%" }} />
                </Form.Item>

                {/* SOLO GUARDAR HEX */}
                <Form.Item
                    label="Color"
                    name="color"
                    rules={[{ required: true, message: "Color requerit" }]}
                >
                    <ColorPicker
                        onChangeComplete={(color) => {
                            form.setFieldValue("color", color.toHexString());
                        }}
                    />
                </Form.Item>

                <Button type="primary" htmlType="submit" block loading={loading}>
                    Crear trofeu
                </Button>
            </Form>
        </Modal>
    );
};

export default NuevoPremioModal;
